import React from "react";

const ManageUserModal = ({
  modalForManageUser,
  selectedLanguage,
  leftSearchValue,
  rightSearchValue,
  temSelectedLeftList,
  temSelectedRightList,
  handleSearchEvent,
  handleToggleClass,
  moveSelectedValueRight,
  moveSelectedValueLeft,
  handlerModelCancelForManageUser,
  handlerModelConfirmForManageUser,
  addInputField
}) => {
  if (!modalForManageUser) return null;

  return (
    <div className="modalCus" id="myModal" style={{ zIndex: 1056 }}>
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header d-flex">
            <h4 className="mb-0 fw-bold font-20" htmlFor="">
              {selectedLanguage.LstLanguageCodes.UI_SelectAutherizedReaders}
            </h4>
          </div>
          <div className="modal-body pb-0 ps-3 pe-3 res-px0">
            <div
              className=" authorizedReaders table-scrollbar"
              style={{
                maxHeight: "350px",
                display: "block",
                paddingRight: "3px",
              }}>
              <div className="select-parent">
                <div className="SelctDiv">
                  <div className="mb-0 fw-bold font-14 pb-2">
                    {selectedLanguage.LstLanguageCodes.UI_ReadersList}
                  </div>
                  <div className="">
                    <input
                      type="search"
                      value={leftSearchValue}
                      onChange={(e) =>
                        handleSearchEvent(e, "left")
                      }></input>
                  </div>
                  <div className="select-tag">
                    {temSelectedLeftList.map((data, index) => (
                      <div
                        key={index + data.email}
                        value={data.email}
                        onClick={(e) => handleToggleClass(e)}
                        className="inActiveUserUnSelected">
                        {
                          <>
                            {(data.firstName != "" && data.firstName != null && data.firstName != undefined &&
                              data.firstName.length > 0) ||
                              (data.reference != "" &&  data.reference != null && data.reference != undefined &&
                                data.reference.length > 0) ||
                              (data.lastName != "" && data.lastName != null && data.lastName != undefined &&
                                data.lastName.length > 0) ||
                              (data.lastName != "" &&
                               data.mobileNumber != "" && data.mobileNumber != undefined && data.mobileNumber.length > 0) ? (
                              <>
                                <>
                                  {" "}
                                  {(data.firstName != "" && data.firstName != null && data.firstName != undefined &&
                                    data.firstName.length) > 0 ? (
                                    <>{data.firstName}</>
                                  ) : (
                                    ""
                                  )}
                                </>
                                <>
                                  {(data.firstName != "" && data.firstName != null && data.firstName != undefined &&
                                    data.firstName.length) > 0 &&
                                    data.lastName != "" && data.lastName != null && data.lastName != undefined &&
                                    data.lastName.length > 0 ? (
                                    <>{" " + data.lastName + " "}</>
                                  ) : (
                                    (data.lastName != "" && data.lastName != null && data.lastName != undefined &&
                                      data.lastName.length) > 0 && (
                                      <>{data.lastName + " "}</>
                                    )
                                  )}
                                </>
                                <>{"<" + data.email + ">"}</>
                                <>
                                  {`${data.mobileCountryCode}` +
                                    " " +
                                    `${data.mobileNumber}`}
                                </> <>
                                  {`${data.reference !== "" ? data.reference : ""}`}
                                </>
                              </>
                            ) : (
                              data.email
                            )
                            }
                          </>
                        }
                      </div>
                    ))}
                  </div>
                </div>
                <div className="select-btn-div">
                  <span
                    className="material-icons pb-0 ps-3 pe-3 pb-3"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      moveSelectedValueRight();
                    }}>
                    arrow_forward
                  </span>
                  <span
                    className="material-icons pb-0 ps-3 pe-3 pb-3"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      moveSelectedValueLeft();
                    }}>
                    arrow_back
                  </span>
                  {/* <button
                        onClick={() => {
                          moveAllValLeft();
                        }}
                      >{`<<`}</button> */}
                </div>
                <div className="SelctDiv">
                  <div className="mb-0 fw-bold font-14 pb-2">
                    {
                      selectedLanguage.LstLanguageCodes
                        .UI_AuthorizedReadersList
                    }
                  </div>
                  <div className="">
                    <input
                      type="search"
                      value={rightSearchValue}
                      onChange={(e) =>
                        handleSearchEvent(e, "right")
                      }></input>
                  </div>
                  <div className="select-tag">
                    {temSelectedRightList.map((data, index) => (
                      <div
                        key={index + data.email}
                        value={data.email}
                        onClick={(e) => handleToggleClass(e)}
                        className="activeUserUnSelected">
                        {
                          <>
                            {(data.firstName != "" && data.firstName != null && data.firstName != undefined &&
                              data.firstName.length > 0) ||
                              (data.reference != "" && data.reference != null && data.reference != undefined &&
                                data.reference.length > 0) ||
                              (data.lastName != "" && data.lastName != null && data.lastName != undefined &&
                                data.lastName.length > 0) ||
                              (data.mobileNumber != "" && data.mobileNumber != null &&
                                data.mobileNumber.length > 0) ? (
                              <>
                                <>
                                  {" "}
                                  {data.firstName != "" && data.firstName != null && data.firstName != undefined &&
                                    data.firstName.length > 0 ? (
                                    <>{data.firstName}</>
                                  ) : (
                                    ""
                                  )}
                                </>
                                <>
                                  {data.firstName != "" && data.firstName != null && data.firstName != undefined &&
                                    data.firstName.length > 0 &&
                                   data.lastName != "" && data.lastName != null && data.lastName != undefined &&
                                    data.lastName.length > 0 ? (
                                    <>{" " + data.lastName + " "}</>
                                  ) : (
                                   data.lastName != "" && data.lastName != null && data.lastName != undefined &&
                                    data.lastName.length > 0 && (
                                      <>{data.lastName + " "}</>
                                    )
                                  )}
                                </>
                                <>{"<" + data.email + ">"}</>
                                <>
                                  {`${data.mobileCountryCode}` +
                                    " " +
                                    `${data.mobileNumber} `}
                                </>

                                <>
                                  {`${data.reference !== "" ? data.reference : ""}`}
                                </>
                              </>
                            ) : (
                              data.email
                            )
                            }
                          </>
                        }
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="pb-4 px-4 d-flex flex-wrap justify-content-between">
            <button
              type="button"
              className="btn btn-outline-success px-2 mt-3 add-reader truncate"
              data-bs-dismiss="modal"
              title={selectedLanguage.LstLanguageCodes.UI_AddReader}
              onClick={addInputField}
              style={{ visibility: "hidden" }}>
              <span
                className="material-icons me-2 font-20"
                style={{ verticalAlign: "bottom" }}>
                add_circle_outline{" "}
              </span>
              {selectedLanguage.LstLanguageCodes.UI_AddReader}
            </button>
            <div className="d-flex align-items-center mt-3">
              <button
                type="button"
                title={selectedLanguage.LstLanguageCodes.UI_Cancel}
                className="btn btn-danger px-2 me-2 ms-1 w-140p truncate"
                data-bs-dismiss="modal"
                onClick={(e) => handlerModelCancelForManageUser()}>
                {selectedLanguage.LstLanguageCodes.UI_Cancel}
              </button>
              <button
                type="button"
                title={selectedLanguage.LstLanguageCodes.UI_OK}
                className="btn btn-primary px-2 ms-1 w-140p truncate"
                onClick={(e) => handlerModelConfirmForManageUser()}>
                {selectedLanguage.LstLanguageCodes.UI_OK}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageUserModal;
